import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import CustomerWalletModalValidity from '../../components/CustomerWalletModalValidity/CustomerWalletModalValidity';
import { customerWalletModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import Input from 'src/view/components/Controls/InputComponent/Input';
import Text, { TEXT } from 'src/view/components/Text/Text';

const CustomerWalletModalTopUpBlock: FC = observer((): JSX.Element | null => {
  const { loading, isTopUpMode, topUp, validation } = customerWalletModalStore;

  const updateAmount = useCallback((value: string | undefined) => {
    customerWalletModalStore.updateAmount(value);
  }, []);

  const updateReason = useCallback((value: string | undefined) => {
    customerWalletModalStore.updateReason(value);
  }, []);

  if (!isTopUpMode) return null;

  return (
    <div className="d-flex flex-column gap-25">
      <div className="d-flex flex-column gap-10">
        <Text type={TEXT.BLOCK_HEADER} text="Top_up_amount" required />
        <Input
          type="floatNumber"
          value={topUp.amount}
          onChangeValue={updateAmount}
          disabled={loading}
          validation={validation.amount}
          placeholder={localeStore.t('Value')}
          contentClassName="full-width"
        />
      </div>

      <div className="d-flex flex-column gap-10">
        <Text type={TEXT.BLOCK_HEADER} text="top_up_reason" required />
        <Input
          type="text"
          value={topUp.reason}
          onChangeValue={updateReason}
          disabled={loading}
          validation={validation.reason}
          placeholder={localeStore.t('Value')}
          contentClassName="full-width"
        />
      </div>

      <CustomerWalletModalValidity />
    </div>
  );
});

export default CustomerWalletModalTopUpBlock;
